// The Overview cards and the CMS goal scoreboard fetch the SAME 30-day series: identical
// meastypes + window ⇒ identical TanStack key ⇒ one request. Change it here, never in a card.
export const OVERVIEW_SERIES_DAYS = 30;

// Withings `getmeasurebyuser`'s enddateymd excludes same-day readings, so end the window
// TOMORROW — else a reading taken today drops out of `measures` (shows only in last_measure).
// `nowMs` is a parameter because a `new Date()` read during render is frozen by the React Compiler
// for the mount: a file left open past midnight kept excluding today's readings (hooks/useNow.ts).
export function measureWindowYmd(days: number, nowMs: number = Date.now()): { startdateymd: string; enddateymd: string } {
  const now = new Date(nowMs);
  const start = new Date(now);
  start.setDate(start.getDate() - days);
  const end = new Date(now);
  end.setDate(end.getDate() + 1);
  return {
    startdateymd: start.toISOString().slice(0, 10),
    enddateymd: end.toISOString().slice(0, 10),
  };
}
